export default {
	sec_01: {
		title: {
			one: '결제',
		},
		desc: {
			one: 'JP WORLD Pay API를 이용한 결제 시스템',
		},
	},

	sec_02: {
		title: {
			one: 'Quick Guide',
		},
		step: {
			one: {
				one: '회원 가입',
				two: 'JP WORLD PAY 홈페이지에서 회원',
				three: '가입을 해 주세요.',
			},
			two: {
				one: '로그인',
				two: 'JP WORLD Pay의 모든 서비스는',
				three: '로그인 후 이용하실 수 있습니다.',
			},
			three: {
				one: '가맹점 등록',
				two: '가맹점 메뉴에서',
				three: '가맹점 등록을 할 수 있습니다.',
				four: '가맹점 이름과 ID를',
				five: '입력 해 주세요.',
			},
			four: {
				one: 'API 발급',
				two: 'Lorem Ipsum Lorem Ipsum',
				three: 'Lorem Ipsum',
			},
		},
	},
};
